export default __webpack_public_path__ + "static/media/Wesley.52255605.png";